import { render, staticRenderFns } from "./TeamPersonnel.vue?vue&type=template&id=7d7af3f3&scoped=true&"
import script from "./TeamPersonnel.vue?vue&type=script&lang=js&"
export * from "./TeamPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./TeamPersonnel.vue?vue&type=style&index=0&id=7d7af3f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7af3f3",
  null
  
)

export default component.exports